import { TRootState, TBillTypesState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { billTypesAdapter } from './adapter'

const selectState = (state: TRootState): TBillTypesState => state.billTypes

const adapterSelectors = billTypesAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

export const selectors = {
    ...adapterSelectors,
    fetchStatus
}